// stores/configsStore.ts
import { defineStore } from 'pinia';
import { loadEnvConfig } from '@/services/config';

interface ConfigState {
  apiHost: string;
  appTitle: string;
}

export const useConfigStore = defineStore('config', {
  state: (): ConfigState => {
    // Try to load env config during store initialization
    try {
      const envConfig = loadEnvConfig();
      return {
        apiHost: envConfig.apiHost,
        appTitle: envConfig.appTitle,
      };
    } catch (error) {
      console.error('Failed to load environment configuration:', error);
      return {
        apiHost: 'http://localhost:3000/api', // Fallback value
        appTitle: 'Metabase Proxy',
      };
    }
  },

  getters: {
    getApiHost: (state) => state.apiHost,
    getAppTitle: (state) => state.appTitle,
  },

  actions: {
    setApiHost(newHost: string) {
      this.apiHost = newHost;
    },
    setAppTitle(newTitle: string) {
      this.appTitle = newTitle;
    },
  },
});